export default function MatchConfirmation({ notification }) {
  const content = notification.notification_body;

  return (
    <div className="w-full border border-black p-2 opacity-45">
      <p>{content.message}</p>
    </div>
  );
}
